import { connectionManager } from './connectionManager';

export const supabase = connectionManager.getClient();

// Verify storage bucket exists
export async function verifyStorageBucket() {
  const client = connectionManager.getClient();
  if (!client) return false;
  
  try {
    // Check if bucket exists
    const { data: buckets, error } = await client.storage.listBuckets();
    
    if (error) throw error;
    
    const sponsorBucket = buckets?.find(b => b.name === 'sponsor-logos');
    
    if (!sponsorBucket) {
      // Create bucket if it doesn't exist
      const { error: createError } = await client.storage.createBucket('sponsor-logos', {
        public: true,
        fileSizeLimit: 2097152, // 2MB
        allowedMimeTypes: ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/svg+xml']
      });
      
      if (createError) throw createError;
    }
    
    return true;
  } catch (error) {
    console.error('Failed to verify storage bucket:', error);
    return false;
  }
}